<template>
  <div>
    <div v-if="objBaseInfo.channelId == 'WEB'">
      <el-popover
        popper-class="dest-popover"
        v-model:visible="visible"
        trigger="manual"
        width="620"
      >
        <div @click="visible = false" class="selectContent">
          <span v-if="$i18n.locale == 'zh'">
            <el-row
              @click="toParam(item, 'search')"
              v-for="(item, index) in resultList"
              :key="index"
              class="item-select-row"
            >
              <el-col :span="2" class="item-icon-size"
                ><svg-icon :icon-class="getIcon(item.locationType)"></svg-icon
              ></el-col>
              <el-col :span="15">
                <el-row>
                  <el-col :span="24">
                    <span class="item-name-span">
                      {{ item.locationCnName }}</span
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <span class="item-next-span" v-if="item.locationType != 5">
                      {{
                        (item.locationType != 0 && item.locationType != 2
                          ? item.cityCnName + ", "
                          : "") +
                        item.provinceCnName +
                        ", " +
                        item.countryCnName
                      }}</span
                    >
                    <span class="item-next-span" v-if="item.locationType == 5">
                      {{ getLocationType(item.locationType) }}</span
                    >
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7"
                ><span class="item-type-span">{{
                  getLocationType(item.locationType)
                }}</span>
              </el-col>
            </el-row>
          </span>
          <span v-if="$i18n.locale == 'en'">
            <el-row
              @click="toParam(item, 'search')"
              v-for="(item, index) in resultList"
              :key="index"
              class="item-select-row"
            >
              <el-col :span="2" class="item-icon-size"
                ><svg-icon :icon-class="getIcon(item.locationType)"></svg-icon
              ></el-col>
              <el-col :span="15">
                <el-row>
                  <el-col :span="24">
                    <span class="item-name-span">
                      {{ item.locationEnName }}</span
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <span class="item-next-span" v-if="item.locationType != 5">
                      {{
                        (item.locationType != 0 && item.locationType != 2
                          ? item.cityEnName + ", "
                          : "") +
                        item.provinceEnName +
                        ", " +
                        item.countryEnName
                      }}</span
                    >
                    <span class="item-next-span" v-if="item.locationType == 5">
                      {{ getLocationType(item.locationType) }}</span
                    >
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="7"
                ><span class="item-type-span">{{
                  getLocationType(item.locationType)
                }}</span>
              </el-col>
            </el-row>
          </span>
        </div>
        <div style="text-align: center; color: #b3acac">{{ tipMessage }}</div>
        
        <template #reference>
          <el-input
            :placeholder="$t('SEARCH.KEYWORDS')"
            v-model="returnParent"
            @input="querySearch"
            @click="historySearch"
            autocomplete="off"
            @blur="visible = false"
          >
            <template #prefix>
              <svg-icon
                icon-class="search"
              ></svg-icon>
            </template>
          </el-input>
        </template>
      </el-popover>
    </div>
    <div
      @click="destPopShow = true"
      v-if="objBaseInfo.channelId == 'MOBILE'"
      style="min-height: 3.1rem"
    >
      <el-input
        v-if="!isMobileResultKeyword"
        :placeholder="$t('SEARCH.KEYWORDS')"
        v-model="returnParent"
        autocomplete="off"
        :readonly="true"
      >
        <template #prefix>
          <svg-icon
            icon-class="search"
          ></svg-icon>
        </template>
      </el-input>
      <!-- result移动端 -->
      <el-input
        type="text"
        v-if="isMobileResultKeyword"
        class="s_input"
        readonly="readonly"
        v-model="returnParent"
        :placeholder="$t('SEARCH.KEYWORDS')"
      >
        <template #prefix>
          <svg-icon
            icon-class="search"
          ></svg-icon>
        </template>
      </el-input>
    </div>
    <van-popup
      :show="destPopShow"
      position="bottom"
      :style="{ height: '60%' }"
      @close="onClosePop"
    >
      <div ref="container">
        <van-sticky :container="container">
          <form>
            <van-search
              v-model="returnParent"
              show-action
              :placeholder="$t('DESTINATION.SEARCHPL')"
              @click="historySearch"
              @update:model-value="onInput"
            >
              <template #action>
                <div v-if="!isMobileResultKeyword" @click="onClosePop">
                  {{ $t("DESTINATION.CLOSEPOP") }}
                </div>
                <div v-if="isMobileResultKeyword" @click="onClosePop('search')">
                  {{ $t("RESULT.SEARCH") }}
                </div>
              </template>
            </van-search>
          </form>
        </van-sticky>
        <van-index-bar :index-list="[]">
          <span>
            <span v-if="$i18n.locale == 'zh'">
              <van-cell
                v-for="item in indexCityInfoList"
                :key="item.locationCode"
                :title="item.locationCnName"
                @click="toParam(item, 'search')"
                class="city-span"
                :value="getLocationType(item.locationType)"
                :label="getCityLable(item)"
              >
                <template #icon>
                  <svg-icon :icon-class="getIcon(item.locationType)"></svg-icon>
                </template>
              </van-cell>
            </span>
            <span v-if="$i18n.locale == 'en'">
              <van-cell
                v-for="item in indexCityInfoList"
                :key="item.locationCode"
                :title="item.locationEnName"
                @click="toParam(item, 'search')"
                class="city-span"
                :value="getLocationType(item.locationType)"
                :label="getCityLable(item)"
              >
                <template #icon>
                  <svg-icon :icon-class="getIcon(item.locationType)"></svg-icon>
                </template>
              </van-cell>
            </span>
            <div style="text-align: center; color: #b3acac">
              {{ tipMessage }}
            </div>
          </span>
        </van-index-bar>
      </div>
    </van-popup>
    <ConfirmBoxss
      :centerDialogVisible="confirmFlags"
      :confirmMsg="confirmMsgs"
      @setConfirmFlag="setConfirmFlags"
    ></ConfirmBoxss>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import ConfirmBoxss from "@/components/confirmBoxs.vue";
import { searchDestination, getKeywordRecords } from "../api/shoppingData.js";
import "vant/lib/index-anchor/style/index";

export default {
  name: "KeywordSearch",
  components: {
    ConfirmBoxss,
  },
  props: {
    parentCityCode: String,
    cityInfo: Object,
    keywordInput: String,
    isVisible: {
      type: Boolean,
    },
    //是否是移动端result页面keywords搜索
    isMobileResultKeyword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmMsgs: "", //提示消息内容
      confirmFlags: false, //提示框是否弹出
      restaurants: [],
      newResultList: [],
      resultList: [],
      returnParent: "",
      cityCode: "",
      visible: false,
      inCityData: [],
      tipMessage: "",
      destPopShow: false,
      indexCityInfoList: [],
      searchCity: "",
      originCityList: [],
      container: null,
      searchTimer: null,
      searchKey: "",
      historyCityCode: "",
      objBaseInfo: {} // 存储全局属性
    };
  },
  methods: {
    getCityLable(item) {
      if (this.$i18n.locale == "zh") {
        if(item.locationType==5)
        {
          return this.getLocationType(item.locationType);
        }
        return (
          (item.locationType != 0 && item.locationType != 2
            ? item.cityCnName + ", "
            : "") +
          item.provinceCnName +
          ", " +
          item.countryCnName
        );
      } else {
        if(item.locationType==5)
        {
          return this.getLocationType(item.locationType);
        }
        return (
          (item.locationType != 0 && item.locationType != 2
            ? item.cityEnName + ", "
            : "") +
          item.provinceEnName +
          ", " +
          item.countryEnName
        );
      }
    },
    getIcon(type) {
      let iconName = "";
      switch (type) {
        case 0:
          iconName = "city";
          break;
        case 1:
          iconName = "district";
          break;
        case 2:
          iconName = "airport";
          break;
        case 3:
          iconName = "custom";
          break;
        default:
          iconName = "city";
          break;
      }
      return iconName;
    },
    getLocationType(type) {
      let locationType = [];
      switch (type) {
        case 0:
          locationType = { "zh-CN": "城市", en: "City" };
          break;
        case 1:
          locationType = { "zh-CN": "行政区", en: "District" };
          break;
        case 2:
          locationType = {
            "zh-CN": "机场/火车站",
            en: "Airport/Railway Stations",
          };
          break;
        case 3:
          locationType = { "zh-CN": "公司地标", en: "Company Locations" };
          break;
        //中文：热门地标，英文：
        case 4:
          locationType = { "zh-CN": "热门地标", en: "Landmark" };
          break;
        case 5:
          locationType = { "zh-CN": "历史记录", en: "History" };
          break;
        default:
          locationType = { "zh-CN": "城市", en: "City" };
          break;
      }
      return locationType[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
    },
    onClosePop(type) {
      this.tipMessage = "";
      this.destPopShow = false;
      this.indexCityInfoList = [];
      if (type == "search") {
        //搜索keywords关键词搜索
        this.$emit("returnKeyWord", {
          keywordType: "input",
          keyword: this.returnParent,
          isSearech: true,
        });
      }
    },
    onInput(val) {
      this.returnParent = val;
      this.querySearch();
      if (!val) {
        this.indexCityInfoList = [];
        this.tipMessage = "";
        clearTimeout(this.searchTimer);
      } 
    },
    setConfirmFlags() {
      this.confirmFlag = false;
    },
    // 输入框搜索
    querySearch() {
      clearTimeout(this.searchTimer);
      this.$emit("returnKeyWord", {
        keywordType: "input",
        keyword: this.returnParent,
      });
      if (this.objBaseInfo.channelId == "WEB") {
        this.tipMessage = "";
        if (this.returnParent.trim() === "") {
          this.visible = false;
          return;
        }
        //this.visible = true;
      }
      if (this.returnParent) {
        var that = this;
        this.searchTimer = setTimeout(function () {
          that.searchInitCity();
        }, 500);
      } else {
        this.resultList = [];
        //this.tipMessage = this.$t("DESTINATION.NOTDEST");
      }
    },
    async historySearch() {
      console.log(this.historyCityCode);
      if (this.historyCityCode == "") {
        return;
      }
      let params = {
        params: {
          cityCode: this.historyCityCode,
        },
      };
      let arr = [];
      this.resultList = [];
      this.indexCityInfoList = [];
      await getKeywordRecords(params)
        .then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.length > 0) {
              if (this.objBaseInfo.channelId != "MOBILE") {
                this.visible = true;
              }
              arr = res.data;
              this.tipMessage = "";
            }
          }
        })
        .catch((err) => {
          console.log("城市信息搜索异常：", err.objError);
        });
      if (arr.length > 0) {
        this.visible = true;
        for (let i = 0; i < arr.length; i++) {
          this.resultList.push({
            locationCnName: arr[i],
            locationEnName: arr[i],
            locationType: 5,
            locationCode: i,
          });
          this.indexCityInfoList.push({
            locationCnName: arr[i],
            locationEnName: arr[i],
            locationType: 5,
            locationCode: i,
          });
        }
      }
    },
    //弹出窗选中值存放以及弹出框显示隐藏控制
    toParam(item, type) {
      if (type == "search") {
        item = {
          aliasName: item.cityAliasName,
          cityCode: item.cityCode,
          cityId: item.pkid,
          cityName: item.cityCnName,
          cityNameLists: { "zh-CN": item.cityCnName, en: item.cityEnName },
          countryCode: item.countryCode,
          countryNameLists: {
            "zh-CN": item.countryCnName,
            en: item.countryEnName,
          },
          destinationType: item.destinationType,
          frequentlyUsedFlag: item.frequentlyUsedFlag,
          geoCodeType: item.cityGeoCodeType,
          latitude: item.cityLatitude,
          longitude: item.cityLongitude,
          provinceCode: item.provinceCode,
          provinceNameLists: {
            en: item.provinceEnName,
            "zh-CN": item.provinceCnName,
          },
          tcCode: item.tcCode,
          timeStamp: item.cityTimeStamp,
          locationName: {
            en: item.locationEnName,
            "zh-CN": item.locationCnName,
          },
          locationCnName: item.locationCnName,
          locationCode: item.locationCode,
          locationEnName: item.locationEnName,
          locationGeoCodeType: item.locationGeoCodeType,
          locationLatitude: item.locationLatitude,
          locationLongitude: item.locationLongitude,
          locationType: item.locationType,
        };
      } else {
        item.locationType = 0;
      }
      if (this.objBaseInfo.channelId === "MOBILE") {
        if(item!=undefined && item.locationType!=undefined && item.locationType!=5)
        {
          this.destPopShow = false;
        }
        this.indexCityInfoList = [];
      }
      if (this.objBaseInfo.channelId === "WEB") {
        this.visible = false;
        this.resultList = [];
      }
      let keywordType = "auto";
      let keyword = item;
      if (item.locationType == 5) {
        keywordType = "input";
        keyword = item.locationCnName;
      }
      this.returnParent =
        item.locationName[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
      this.$emit("returnKeyWord", {
        keywordType: keywordType,
        keyword: keyword,
      });
    },
    clearSearchResult() {
      this.visible = false;
      this.indexCityInfoList = [];
      this.resultList = [];
      //this.tipMessage = this.$t("DESTINATION.NOTDEST");
    },
    async searchInitCity() {
      //this.tipMessage = this.$t("DESTINATION.WAITSEARCHTIP");
      // 城市搜索
      let params = {
        params: {
          keyword: this.returnParent,
          pageNumber: 1,
          pageSize: 100,
          destinationType: this.objBaseInfo.destinationType,
          locationType: "2,3,4",
          customerCode: this.objBaseInfo.customerCode,
        },
      };
      await searchDestination(params)
        .then((res) => {
          if (res.code === 200) {
            if (res.data.error.code != 0) {
              console.log(
                "城市信息搜索失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              if (res.data.list && res.data.list.length > 0) {
                if (this.objBaseInfo.channelId == "MOBILE") {
                  this.indexCityInfoList = res.data.list;
                } else {
                  this.visible = true;
                  this.resultList = res.data.list;
                }
                this.tipMessage = "";
              } else {
                this.clearSearchResult();
                console.log("无搜索结果");
              }
            }
          } else {
            this.clearSearchResult();
            console.log("城市信息搜索失败, code:" + res.code, res.message);
          }
        })
        .catch((err) => {
          this.clearSearchResult();
          console.log("城市信息搜索异常：", err.objError);
        });
    },
  },
  mounted() {
    // 获取全局属性
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    
    this.container = this.$refs.container;
    if(this.parentCityCode!=undefined && this.parentCityCode!=null && this.parentCityCode!="")
    {
      this.historyCityCode = this.parentCityCode;
    }
  },
  watch: {
    keywordInput(newValue) {
      this.returnParent = newValue;
      // this.visible = false;
    },
    "$i18n.locale"() {
      this.resultList = this.indexCityInfoList = [];
      this.visible = false;
    },
    isVisible() {
      this.visible = false;
    },
    parentCityCode(newVal, oldVal) {
      if (newVal != oldVal) {
        this.historyCityCode = newVal;
      }
    },
  },
};
</script>
<style lang="stylus">
/* 手机屏幕 */
@media screen and (max-width: 960px) {
  .el-popover.dest-popover {
    min-width: 0px;
    width: 80%;
  }

  .list_city {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 7rem;
    color: $btn-bg-color;
    text-align: center;
  }
}

@media screen and (min-width: 961px) {
  .el-popover.dest-popover {
    min-width: 15rem;
    min-height: 2rem;
    width: 60rem;
  }
}
</style>
<style lang="stylus" scoped>
@media screen and (min-width: 961px) {
  .scroll_hot {
    overflow-y: auto;
    max-height: 14rem;
  }

  /* 弹出窗 热门城市面板 */
  ul {
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    box-sizing: border-box;
  }

  li {
    text-align: -webkit-match-parent;
    width: 15%;
  }

  li, ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  ul li span {
    display: block;
    padding: 1px 5px;
    height: 30px;
    font-size: 14px;
    color: #333;
    letter-spacing: 0;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  .title {
    font-size: 14px;
    color: #666;
    background: #f7f7fb;
    height: 30px;
    line-height: 30px;
    padding-left: 8px;
    font-weight: 700;
  }

  .city-span:hover {
    background: #007aff;
    color: white;
  }

  /* 弹出窗 搜索 */
  .el-row {
    font-size: 14px;
    // padding: 5px 0px ;
  }

  .el-row:hover, .el-row:active {
    border-radius: 10px;
    background: #badbff;
  }

  .item-icon-size {
    padding-left: 1rem;
    height: 4rem;
    line-height: 5rem;
  }

  .item-type-span {
    line-height: 4rem;
    font-size: 12px;
    color: #999;
  }

  .item-name-span {
    line-height: 2.3rem;
    font-size: 1.4rem;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .item-next-span {
    font-size: 1.2rem;
    color: #999;
  }

  .item-select-row {
    padding: 0.2rem 0;
  }

  ::-webkit-scrollbar {
    width: 1rem;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 3;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
    background-color: $scrollbar-thumb-hover-color;
  }

  .selectContent {
    max-height: 200px;
    overflow: auto;
  }
}

/* 手机屏幕 */
@media screen and (max-width: 960px) {
  .van-search.van-search--show-action {
    padding: 0.5rem;
  }

  .city-span.van-cell {
    padding: 1rem 2rem;

    .svg-icon {
      margin-right: 1rem;
    }
  }

  /* 弹出窗 热门城市面板 */
  ul {
    padding: 5px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    box-sizing: border-box;
  }

  li {
    text-align: -webkit-match-parent;
    width: 33%;
  }

  li, ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  ul li span {
    display: block;
    padding: 0.5rem;
    height: 3rem;
    font-size: 1.6rem;
    color: #333;
    letter-spacing: 0;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }

  .title {
    font-size: 1.6rem;
    color: #666;
    background: #f7f7fb;
    height: 3rem;
    line-height: 30px;
    padding-left: 0.5rem;
    font-weight: 700;
  }

  .city-span:hover {
    background: #007aff;
    color: white;
  }

  /* 弹出窗 搜索 */
  .el-row {
    font-size: 14px;
    padding: 5px 0px;
  }

  .el-row:hover, .el-row:active {
    border-radius: 10px;
    background: #badbff;
  }

  .item-icon-size {
    padding-left: 1rem;
  }

  .item-type-span {
    padding-top: 4px;
    font-size: 12px;
    color: #999;
  }

  .item-name-span {
    padding-top: 5px;
    font-size: 14px;
  }

  ::-webkit-scrollbar {
    width: 1rem;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 3;
    /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
    background-color: $scrollbar-thumb-hover-color;
  }

  .selectContent {
    max-height: 200px;
    overflow: auto;
  }

  .s_input.el-input ::v-deep .el-input__inner {
    border: 0;
  }
  :deep(.el-input__inner){
    padding-left:0px !important;
  }
}
</style>